var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._b({},'v-row',_vm.config.props,false),_vm._l((_vm.config.children),function(colConfig,index){return _c('ServiceSequenceLayoutColumn',{key:index,attrs:{"config":colConfig,"componentConfigs":_vm.componentConfigs}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }